<!--Options-->
<div class="MainGrid2Col">
	<label for="IncludeHeaders">Include Column Headers:</label>
	<input class="CHK" id="IncludeHeaders" [disabled]="IsLoading() == true" type="checkbox" [(ngModel)]="IncludeHeaders" />

	<label for="IncludeOffenders">Include Unblocked Offenders:</label>
	<input class="CHK" id="IncludeOffenders" [disabled]="IsLoading() == true" type="checkbox" [(ngModel)]="IncludeOffenders" />

	<label>Format:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="SelectedFormatOption" [(ngModel)]="SelectedFormatOption">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstFormatOptions" [ngValue]="o">
			{{ o.Desc }}
		</option>
	</select>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onExport()">Export</button>
	<button class="btn btn-warning SmallLeftMargin" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
